var _g, _path, _g2, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMintPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10900_8615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5002 6.38194C21.8031 6.38194 26.118 10.696 26.1187 15.9988C26.1193 21.3023 21.8051 25.6177 16.5015 25.6177L16.4995 25.5194L16.4989 25.6177C11.1973 25.6177 6.88305 21.3036 6.88173 16.0008C6.88173 10.698 11.1966 6.3826 16.5002 6.38194ZM7.82114 15.9992C7.82114 20.7843 11.7139 24.6782 16.4991 24.6789C21.2803 24.6743 25.1743 20.7816 25.1796 16.0005C25.1803 11.2149 21.2869 7.32089 16.501 7.32089C14.1833 7.32089 12.0035 8.22315 10.3638 9.86213C8.72475 11.5018 7.82114 13.6809 7.82114 15.9992Z",
    fill: "#FEA503"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3034 21L15.9022 17.0833H13.7702C13.6631 17.0833 13.5852 17.037 13.5365 16.9444C13.4878 16.8519 13.4878 16.7639 13.5365 16.6806L17.1142 11H17.7129L17.1142 14.9028H19.217C19.3241 14.9028 19.4044 14.9491 19.4579 15.0417C19.5115 15.1343 19.5139 15.2222 19.4652 15.3056L15.9022 21H15.3034Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10900_8615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79484 10.248C6.53432 10.248 6.32259 10.0363 6.32259 9.77383C6.32259 9.51331 6.53497 9.30225 6.7955 9.30225C7.05603 9.30291 7.26709 9.51528 7.26709 9.77581C7.26709 10.0363 7.05537 10.248 6.79484 10.248Z",
    fill: "#FEA503"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10900_8615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90203 12.9249C4.93699 12.8048 5.01613 12.7052 5.12562 12.6452C5.23511 12.5845 5.3624 12.5707 5.48178 12.6057C5.60249 12.6406 5.70142 12.7198 5.7621 12.8292C5.82212 12.9394 5.83663 13.066 5.80233 13.1834C4.89674 16.6183 5.71131 20.2993 7.98088 23.0311C11.8631 27.7034 18.8222 28.3471 23.4959 24.4663C28.1682 20.5842 28.812 13.6246 24.9304 8.95175C23.05 6.68752 20.4005 5.29192 17.4701 5.0215C14.5436 4.74712 11.6797 5.63619 9.41676 7.51591C9.33365 7.58714 9.22746 7.62606 9.11864 7.62672H9.11732C8.97815 7.62672 8.8469 7.56604 8.75654 7.46051C8.67475 7.36421 8.63452 7.24153 8.64441 7.11556C8.6543 6.98959 8.71301 6.87483 8.80996 6.79239C10.7636 5.16 13.138 4.20431 15.6774 4.02954C18.8756 3.80661 21.9657 4.84606 24.3823 6.95068C26.799 9.0553 28.2513 11.9751 28.4716 15.172C28.4908 15.4443 28.5 15.7233 28.5 15.9997C28.5007 22.6163 23.1179 27.9989 16.5018 27.9995H16.482C16.2934 27.9995 16.1028 27.9949 15.9122 27.9857C15.0745 27.9448 14.2382 27.8155 13.4256 27.6005C7.03176 25.9081 3.20628 19.3284 4.90203 12.9249Z",
    fill: "#FEA503"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10900_8615",
    x: 2.88184,
    y: 2.38184,
    width: 27.2368,
    height: 27.2358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10900_8615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10900_8615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10900_8615",
    x: 2.32275,
    y: 5.30225,
    width: 8.94434,
    height: 8.9458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10900_8615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10900_8615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10900_8615",
    x: 0.5,
    y: 0,
    width: 32,
    height: 31.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10900_8615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10900_8615",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintPower);
export default __webpack_public_path__ + "static/media/mintPower.7d2dfbcd32fc11af959c2e582491b481.svg";
export { ForwardRef as ReactComponent };